import {Component, LOCALE_ID, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { AuthService } from "./auth/auth.service";
import { VERSION_NUMBER } from "../environments/version.info";
import { Title } from "@angular/platform-browser";
import {LanguageService} from 'src/app/shared/language.service';

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit  {
  private readonly languageService = inject(LanguageService);
  private authService = inject(AuthService);
  private titleService = inject(Title);
  protected localeId = inject(LOCALE_ID);

  title = "ServiceAdminApp";
  languageList = [
    { code: "en", label: "English", path: "./assets/icons/gb-flag.svg" },
    { code: "pl", label: "Polski", path: "./assets/icons/pl-flag.svg" },
  ];
  versionNumber = VERSION_NUMBER;

  constructor() {
    this.authService.autoAuth();
    console.log("AppComponent constructor");
    this.titleService.setTitle("Service Admin");
  }

  ngOnInit(): void {
    this.languageService.loadLanguages().subscribe();
  }

  get userName() {
    return this.authService.userName;
  }

  signOut() {
    this.authService.logout();
  }
}
